import { config } from 'zod/v4/core';
import en from 'zod/v4/locales/en.js';

// Loaded by the Angular polyfills entry before the application module graph.
// Zod captures this flag during object-schema creation, so even an early main
// import can run too late when application dependencies have already evaluated.
// Our CSP forbids dynamic code generation, so skip even the caught eval probe.
// Configure English explicitly: named Zod imports otherwise omit the default
// locale, changing validation messages while avoiding the full locale catalogue.
config({ ...en(), jitless: true });
